/* WiseCar V3 ana sayfa: slider ve ürün sekmeleri */
(function () {
  if (window.__wc3Loaded) return;
  window.__wc3Loaded = true;
  if (!customElements.get('wc3-slider')) {
    customElements.define('wc3-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.wc3-slide')];
        this.tabs = [...this.querySelectorAll('.wc3-hero__tab')];
        this.index = 0;
        this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.go(i, true)));
        const prev = this.querySelector('.wc3-arrow--prev');
        const next = this.querySelector('.wc3-arrow--next');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.speed = parseInt(this.dataset.autoplay || '0', 10);
        this.canAuto = this.speed > 0 && this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.stop(); });
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        // Mobilde parmakla kaydırma
        this.addEventListener('touchstart', (e) => { this.tx = e.touches[0].clientX; this.ty = e.touches[0].clientY; this.stop(); }, { passive: true });
        this.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - this.tx;
          const dy = e.changedTouches[0].clientY - this.ty;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1), true);
          else this.start();
        }, { passive: true });
        this.start();
      }
      start() {
        this.stop();
        if (this.canAuto && !this.matches(':hover') && !this.querySelector(':focus-visible')) {
          this.timer = setInterval(() => this.go(this.index + 1), this.speed * 1000);
        }
      }
      stop() { clearInterval(this.timer); }
      go(i, user) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const on = k === this.index;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        this.tabs.forEach((t, k) => {
          const on = k === this.index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (user) this.start();
      }
      disconnectedCallback() { this.stop(); }
    });
  }

  if (!customElements.get('wc3-tabs')) {
    customElements.define('wc3-tabs', class extends HTMLElement {
      connectedCallback() {
        this.buttons = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.buttons.forEach((b, i) => {
          b.addEventListener('click', () => this.select(i));
          b.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault();
              const n = this.buttons.length;
              const j = (i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
              this.select(j);
              this.buttons[j].focus();
            }
          });
        });
      }
      select(i) {
        this.buttons.forEach((b, k) => {
          b.setAttribute('aria-selected', k === i ? 'true' : 'false');
          b.tabIndex = k === i ? 0 : -1;
        });
        this.panels.forEach((p, k) => { p.hidden = k !== i; });
      }
    });
  }

  if (!customElements.get('wc3-finder')) {
    customElements.define('wc3-finder', class extends HTMLElement {
      connectedCallback() {
        this.s = { use: 'fixed', phase: 'tri', car: '22', batt: this.dataset.defaultBattery || '60' };
        this.addEventListener('click', (e) => {
          const b = e.target.closest('[data-q]');
          if (!b || !this.contains(b)) return;
          this.s[b.dataset.q] = b.dataset.v;
          this.render();
        });
        this.render();
      }
      render() {
        const s = this.s;
        this.querySelectorAll('[data-q]').forEach((b) => b.setAttribute('aria-pressed', String(s[b.dataset.q] === b.dataset.v)));
        const tri = s.phase === 'tri';
        const car = parseFloat(s.car);
        const key = (s.use === 'fixed' ? 'fixed' : 'port') + '_' + (tri && car > 7.4 ? 'tri' : 'mono');
        let card = null;
        this.querySelectorAll('.wc3-finder__card').forEach((c) => {
          const on = c.dataset.key === key;
          c.hidden = !on;
          if (on) card = c;
        });
        const charger = card ? parseFloat(card.dataset.kw) || 7.4 : 7.4;
        const kw = Math.min(charger, tri ? 22 : 7.4, car);
        const hours = parseFloat(s.batt) / kw;
        let h = Math.floor(hours);
        let m = Math.round(((hours - h) * 60) / 5) * 5;
        if (m === 60) { h += 1; m = 0; }
        // Dile göre metinler Liquid'den data-* ile gelir; yoksa Türkçe
        const d = this.dataset;
        const fmt = (n) => String(n).replace('.', d.dec || ',');
        const time = this.querySelector('[data-out="time"]');
        if (time) time.textContent = '≈ ' + [h ? h + ' ' + (d.tH || 'sa') : '', m ? m + ' ' + (d.tM || 'dk') : ''].filter(Boolean).join(' ');
        const power = this.querySelector('[data-out="power"]');
        if (power) power.textContent = (d.tPower || '{b} kWh batarya, {k} kW şarj gücüyle boştan doluya.').replace('{b}', fmt(s.batt)).replace('{k}', fmt(kw));
        const notes = {
          unknown: s.phase === 'unknown',
          mono: s.phase === 'mono' && car > 7.4,
          car7: tri && car <= 7.4,
          future: tri && car === 11 && charger > 11,
        };
        this.querySelectorAll('[data-note]').forEach((n) => { n.hidden = !notes[n.dataset.note]; });
      }
    });
  }

  if (!customElements.get('wc3-video')) {
    customElements.define('wc3-video', class extends HTMLElement {
      connectedCallback() {
        const btn = this.querySelector('.wc3-why__play');
        this.dialog = this.querySelector('.wc3-modal');
        this.tpl = this.querySelector('template');
        if (!btn || !this.dialog || !this.tpl) return;
        this.body = this.dialog.querySelector('.wc3-modal__body');
        btn.addEventListener('click', () => this.open());
        this.dialog.querySelector('.wc3-modal__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => { this.body.innerHTML = ''; });
      }
      open() {
        this.body.innerHTML = '';
        this.body.appendChild(this.tpl.content.cloneNode(true));
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        const v = this.body.querySelector('video');
        if (v) {
          v.muted = false;
          v.play().catch(() => { v.muted = true; v.play().catch(() => {}); });
        }
      }
    });
  }
})();
